import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateHomework = (props) => {
  return (
    <Create
// @ts-ignore
      title='Create Homework'
      fields={fields}
      apiPath='admin/homeworks'
      successRedirectPath={resource => `/write-now/homework/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateHomework
